import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import i18n from "../../../i18n";



const viewportWidth =  window.innerWidth;
const viewportHeight = window.innerHeight;

let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize14, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize14 = 14;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize14 = 13;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize14 = 12;
   titleFontSize13 = 11;
}

function replaceWithBr(s) {

  return s.replace(/\n/g, "<br />")
        .replace(/\*\*\*(.*?)\*\*\*/g, '<b><i>$1</i></b>')
        .replace(/\*\*(.*?)\*\*/g, '<i>$1</i>')
        .replace(/\*(.*?)\*/g, '<b>$1</b>')
        .replace(/\b(https?:\/\/\S+|www\.\S+)\b/g, (match) => {
            // Check if the link starts with "www." and does not include a protocol
            if (match.startsWith('www.')) {
              return `<a href="http://${match}" target="_blank">${match}</a>`;
            } else {
              return `<a href="${match}" target="_blank">${match}</a>`;
            }
        })
}

function parseAbout(nameone,nametwo) {
     let texte;
     if (nameone !== "")
     {
        texte = nameone;
      }
      else if (nametwo !== "")
      {
         texte = nametwo;
      }
      else
      {
         texte = ""
      }
      // Liste des voyelles (y compris "Y")
      const voyelles = ['A', 'E', 'I', 'O', 'U', 'Y'];

      // Convertir le texte en majuscules pour la comparaison insensible à la casse
      const texteMajuscules = texte.toUpperCase();

      // Vérifier si le premier caractère est une voyelle
      if (texte === "")
      {
        return ``;
      }
      else if (voyelles.includes(texteMajuscules.charAt(0))) {
        return ` d'${texte}`;
      } else {
        return ` de ${texte}`;
      }
}


function checkType(obj) {
  if (Array.isArray(obj)) {
    return 'array'
  } else if (typeof obj === 'object' && obj !== null) {
    return 'hash'
  } else {
    return 'null'
  }
}


class LanguagesBox extends Component {
  constructor(props) {
    super(props);
    this.popupRef = createRef();

    this.state = {
     processing: false,
     showInnerDiv: true,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
      this.closePopup(); // Call the function to close the popup
    }
  }

  closePopup() {
    this.setState({
      showInnerDiv: false
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);

  }

  displayInnerDiv() {
    this.setState({
      showInnerDiv: true
    });
  }




  render() {
    return (
      <div style={{position: 'fixed', zIndex: 99, width: '100%', height: '100%', top: 0, left: 0, bottom: 0, display: 'flex',
                               justifyContent: 'center', alignItems: 'center',backgroundColor: 'rgba(0,0,0,0.7)'}}>

             <div className="scroll-area"
                     style={{
                       width: '100%',
                       maxHeight: "100vh",
                       overflowY: "auto",
                       position: "relative",
                       zIndex: 0,
                     }}
                   >

               <div style={{width: '100%', minHeight: viewportHeight+'px',}}>

                    <AnimatePresence>

                        {this.state.showInnerDiv && (

                            <motion.div ref={this.popupRef}
                                   initial={{ scale: 0, opacity: 0 }}
                                   exit={{ scale: 0, opacity: 0 }}
                                   whileInView={{ scale: 1, opacity: 1 }}
                                   transition={{ duration: 0.4, ease: 'easeOut' }}
                                   style={{position: 'relative', width: '900px',
                                         minHeight: viewportHeight*1.1+'px',
                                         margin: 'auto', marginTop: '20px', marginBottom: '40px',
                                         backgroundColor: 'white',
                                         borderRadius: '8px',}}>

                                   <div onClick={this.closePopup.bind(this)} style={{position: 'absolute', cursor: 'pointer', right: 10, top: 10, zIndex: 3}}>
                                      <img src={'/img/cancel_icon_grey.png'} style={{width: '40px', height: '40px'}}/>
                                   </div>


                                    <div style={{padding: '20px'}}>





                                    </div>

                             </motion.div>
                         )}

                     </AnimatePresence>

                  </div>

              </div>

       </div>
    );
  }
}

export default LanguagesBox;
